import globalMessage from "@/utils/globalMessage";
import React, { useState } from "react";
import moment from "moment/moment";
import { api } from "@redux/api";
import ScenarioLookup from "@containers/Lookup/ScenarioLookup";
import { useAuth, AUTH_LEVEL } from "@/hooks/use-auth";

const ScenarioFilter = (props) => {
    const hasReadOnly = useAuth("scenario", AUTH_LEVEL.READ_ONLY);
    const canWrite = useAuth("scenario", AUTH_LEVEL.WRITE);
    const canFullAccess = useAuth("scenario", AUTH_LEVEL.FULL_ACCESS);
    const [state, setState] = useState({
        componentKey: 0,
        visible: false,
        isNewScenario: false,
    });

    const openScenario = (event, isNewScenario) => {
        setState((prev) => ({
            ...prev,
            visible: true,
            isNewScenario,
        }));
        props.handleOpenScenario(true, isNewScenario);
    };

    const handleSelectedScenario = (selectedScenario) => {
        props.handleSelectedScenario(selectedScenario.record);
    };

    const handleEdit = (record) => {
        const newState = {
            name: record.name,
            scenario_name: record.name,
            usedModuleValue: record.use_breakpoints,
            selectedScenarioId: record.id,

            gas_price_type: record.gas_type,
            gas_Baseline_Date: [
                record.gas_baseline_start_date ? moment(record.gas_baseline_start_date) : null,
                record.gas_baseline_end_date ? moment(record.gas_baseline_end_date) : null,
            ],
            gas_Start_Date: [moment().subtract(12, "months"), moment()],
            gas_Post_Date: [
                record.gas_post_start_date ? moment(record.gas_post_start_date) : null,
                record.gas_post_end_date ? moment(record.gas_post_end_date) : null,
            ],
            gas_Price: record.gas_price,
            gas_Custom_Price: record.gas_price,
            gas_Option: record.gas_type,
            gas_type: record.gas_type,
            gas_breakpoint0: record.gas_breakpoint0,
            gas_breakpoint1: record.gas_breakpoint1,
            gas_breakpoint2: record.gas_breakpoint2,
            gas_breakpoint3: record.gas_breakpoint3,
            gas_n_segments: record.gas_segment,
            gas_usedModuleValue: record.gas_use_breakpoints || "Breakpoints",
            gas_range0: record.gas_range0,
            gas_range1: record.gas_range1,

            elec_price_type: record.elec_type,
            elec_Baseline_Date: [
                record.elec_baseline_start_date ? moment(record.elec_baseline_start_date) : null,
                record.elec_baseline_end_date ? moment(record.elec_baseline_end_date) : null,
            ],
            elec_Start_Date: [moment().subtract(12, "months"), moment()],
            elec_Post_Date: [
                record.elec_post_start_date ? moment(record.elec_post_start_date) : null,
                record.elec_post_end_date ? moment(record.elec_post_end_date) : null,
            ],
            elec_Price: record.elec_price,
            elec_Custom_Price: record.elec_price,
            elec_Option: record.elec_type,
            elec_type: record.elec_type,
            elec_breakpoint0: record.elec_breakpoint0,
            elec_breakpoint1: record.elec_breakpoint1,
            elec_breakpoint2: record.elec_breakpoint2,
            elec_breakpoint3: record.elec_breakpoint3,
            elec_n_segments: record.elec_segment,
            elec_usedModuleValue: record.elec_use_breakpoints || "Breakpoints",
            elec_range0: record.elec_range0,
            elec_range1: record.elec_range1,
            elec_use_latest_month: record.elec_use_latest_month,
            gas_use_latest_month: record.gas_use_latest_month,
            public: record.public,
        };

        setState((prev) => ({
            ...prev,
            visible: true,
            isNewScenario: false,
        }));
        props.handleOpenScenario(true, false, newState);
    };

    const handleDelete = (id) => {
        api.deleteScenario(id)
            .then(() => {
                globalMessage.success({
                    message: "Success",
                    description: "Scenario was successfully deleted",
                    placement: "topLeft",
                });
                setState((prev) => ({
                    ...prev,
                    componentKey: prev.componentKey + 1,
                    visible: false,
                }));
            })
            .catch((error) => {
                globalMessage.error({
                    message: "Error",
                    description: error.message,
                    placement: "topLeft",
                });
            });
    };

    if (!hasReadOnly) return null;

    return (
        <div className="savings-analysis-toolbar__scenario mr-0 sm:mr-4">
            <ScenarioLookup
                key={state.componentKey}
                SelectedScenario={handleSelectedScenario}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handleOpenScenario={openScenario}
                canWrite={canWrite}
                canFullAccess={canFullAccess}
            />
        </div>
    );
};

export default ScenarioFilter;
